import { ReactNode, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { AuthContext, useAuth } from '../context/AuthContext';

interface IPublicRoute {
  children: ReactNode;
}

export function PublicRoute({ children }: IPublicRoute) {
  const { isAuthenticated } = useContext(AuthContext);
  const { signOut } = useAuth();

  const location = useLocation();


  if (isAuthenticated) {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const agent = params.get('agent');
    const secret = params.get('secret');
    const tokenItem = params.get('tokenItem');

    if (location.pathname === '/login' && (token || agent || secret || tokenItem)) {
      signOut();
      return <>{children}</>;
    }
  }

  return isAuthenticated ? <Navigate to="/" /> : <>{children}</>;
}
